<template>
    <div class="flex-1">
        <div class="h-full w-full flex-1 flex items-stretch">
            <div class="h-full relative border-r bg-gray-100" style="width: 300px;">
                <div class="absolute inset-0 flex flex-col h-full">
                    <div class="text-sm border-b p-2 text-gray-500">
                        <div class="flex items-center justify-end space-x-2">
                            <div class="cursor-pointer hover:text-gray-700" v-shortkey="{windows: ['alt', 'shift', 'n'], mac: ['meta', 'shift', 'n']}" @shortkey="addNewNote()" @click="addNewNote()" v-tooltip="{content: 'Create new note [(alt|cmd)+shift+n]', placement: 'bottom'}">
                                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="document-add w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                            </div>
                            <div class="cursor-pointer hover:text-gray-700 relative" v-shortkey="{windows: ['alt', 'shift', 'f'], mac: ['meta', 'shift', 'f']}" @shortkey="showAddNewFolder()" @click="showAddNewFolder()" v-tooltip="{content: 'Create new folder [(alt|cmd)+shift+f]', placement: 'bottom'}">
                                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="folder-add w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path></svg>
                            </div>
                        </div>
                        <div class="w-full mt-2" v-if="newFolderVisible">
                            <form @submit.prevent="addNewFolder()">
                                <input v-focus type="text" v-model="folderName" class="w-full border bg-white p-1 px-2 text-xs placeholder-gray-500 focus:outline-none focus:shadow-focus focus:border-gray-400" placeholder="Enter folder name" />
                            </form>
                        </div>
                    </div>
                    <div class="p-2" v-if="notes.length > 0">
                        <note-list v-model="notes" :key="flatNotes" />
                    </div>
                </div>
            </div>
            <div v-if="noteData" class="flex-1 h-full relative border-r">
                <textarea v-model="noteData.content" :disabled="noteDataIsEmpty" class="block p-4 w-full absolute inset-0 focus:outline-none text-sm resize-none" wrap="hard" placeholder="Create or select a note to start writing!"></textarea>
            </div>
            <div v-if="$store.state.showOutput" class="max-w-full flex-1 max-h-full relative">
                <div v-if="noteData" class="absolute inset-0 overflow-auto p-4">
                    <note-content></note-content>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import _ from 'lodash';
    // import { mapGetters } from 'vuex';
    import { mapState } from 'vuex';
    import { uuid } from '@cfworker/uuid';
    import NoteContent from '@/components/NoteContent.vue';
    import NoteList from '@/components/NoteList.vue';
    import moment from 'moment';
    import { sha256 } from 'js-sha256';

	export default {
        name: 'Home',
        data () {
            return {
                folderName: '',
                newFolderVisible: false,
            }
        },
        components: {
            NoteContent, NoteList
        },
        mounted () {
            // if (localStorage.note) {
            //     this.$store.dispatch('addNote', {
            //         id: uuid('_'),
            //         content: localStorage.note,
            //     });

            //     localStorage.removeItem('note');
            // }

            if (this.notes.length <= 0) {
                this.$store.dispatch('addNote', {
                    id: uuid('_'),
                    content: '# Start writing your notes here',
                    created: moment().toISOString(),
                    updated: moment().toISOString()
                });
            }

            this.$store.subscribe((mutation, state) => {
                localStorage.setItem('store', JSON.stringify(state));
            });
        },
		computed: {
            notes: {
                get () {
                    return this.$store.state.notes;
                },
                set (value) {
                    this.$store.dispatch('updateNoteList', value);
                }
            },
            flatNotes () {
                return sha256(JSON.stringify(this.notes.flat(10)));
            },
            ...mapState(['noteData']),
            noteDataIsEmpty () {
                return _.isEmpty(this.noteData);
            },
        },
        watch: {
            noteData: {
                deep: true,
                handler (newVal) {
                    if (newVal) {
                        newVal.updated = moment().toISOString();

                        this.$store.dispatch('updateNote', newVal);
                    }
                }
            },
            notes: {
                deep: true,
                handler (newVal) {
                    if (newVal) {
                        this.$store.dispatch('updateNoteList', newVal);
                    }
                }
            }
        },
		methods: {
            showAddNewFolder () {
                this.newFolderVisible = !this.newFolderVisible;
            },
            addNewNote () {
                var id = uuid('_');
                this.$store.dispatch('addNote', {
                    id: id,
                    content: '# Start writing your notes here',
                    created: moment().toISOString(),
                    updated: moment().toISOString(),
                });
                this.selectNote(id);
            },
            addNewFolder () {
                if (!this.folderName) {
                    return;
                }
                
                var id = uuid('_');
                this.$store.dispatch('addNote', {
                    id: id,
                    folder: true,
                    notes: [],
                    editable: false,
                    created: moment().toISOString(),
                    updated: moment().toISOString(),
                    content: this.folderName,
                });

                this.folderName = '';
                this.newFolderVisible = false;
            },
            removeNote (note) {
                if (note) {
                    if (confirm('Are you sure?')) {
                        this.$store.dispatch('removeNote', note);
                    }
                }
            },
            getTitle (content) {
                var firstLine = content.split('\n')[0];
                var title = firstLine.replace('#', '');

                return title || 'Start writing your notes here';
            },
            getContent (content) {
                var noHeader = content.split('\n');
                noHeader.shift();

                return noHeader.join('\n');
            },
            onProgress (progress) {
                this.fileGeneratingProgress = progress;
            },
            hasGenerated () {
                setTimeout(() => {
                    this.fileGeneratingProgress = 0;
                }, 2000);
            },
            selectNote(note) {
                this.$store.dispatch('showNote', note);
            }
		}
	}
</script>
